import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './RealEstate.css';

const RealEstate: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Carousel images - can be extended with more Ansuvara Heights images
  const carouselImages = [
    {
      src: '/images/real_estate.jpg',
      alt: 'Ansuvara Heights - Main View'
    },
    {
      src: '/images/real_estate1.jpg', // Replace with actual Ansuvara Heights images when available
      alt: 'Ansuvara Heights - Mountain View'
    }
  ];

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [carouselImages.length]);

  return (
    <div className="venture-page">
      <div className="venture-container">
        {/* Carousel Header with Overlay Title */}
        <div className="carousel-container">
          <div className="carousel-wrapper">
            <div 
              className="carousel-slide"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {carouselImages.map((image, index) => (
                <div key={index} className="carousel-item">
                  <div 
                    className="carousel-background"
                    style={{ backgroundImage: `url(${process.env.PUBLIC_URL}${image.src})` }}
                  />
                </div>
              ))}
            </div>
            
            {/* Overlay Title */}
            <div className="carousel-title-overlay">
              <h1 className="carousel-title">REAL ESTATE</h1>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="venture-content">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="venture-main-section"
          >
            <div className="venture-content-container">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                viewport={{ once: true }}
                className="venture-text-section"
              >
                <div className="venture-text-content">
                  <div className="venture-text">
                    <p>
                      Ansuvara Group has established a commanding and influential presence in Pokhara's real estate landscape, emerging as one of the region's most trusted and forward-thinking property developers. Over the past three decades, the Group has successfully developed, managed, and transformed 2,000+ ropanis of land across key strategic locations including Birauta, Gharipatan, Chauthe, Nayagaun, Rambazar, and Talchowk. Each of these areas represents a unique chapter in the Group's real estate journey, ranging from early land development and plotted housing to modern townships and integrated residential-commercial neighborhoods.
                    </p>
                    <p>
                      With Pokhara evolving into one of Nepal's fastest-growing urban centers, Ansuvara Group has remained at the forefront of shaping its growth by prioritizing planned development, long-term sustainability, and functional urban design. Driven by a vision to support Pokhara's transition into a modern yet environmentally harmonious city, the Group focuses on creating developments that balance urban convenience with respect for the valley's ecological and cultural identity.
                    </p>
                    <p>
                      Ansuvara Group's real estate philosophy blends quality engineering, thoughtful planning, accessible road networks, community-friendly open spaces, and green buffers that preserve the city's natural beauty. Whether developing residential colonies, high-value plotted housing, or mixed-use commercial corridors, the Group ensures every project supports community well-being, enhances land value, and contributes to the broader urban fabric of Pokhara. With a foundation built on trust, transparency, and timely delivery, Ansuvara Group stands as one of the most consistent contributors to Pokhara's expanding real estate horizon.
                    </p>
                    
                    <h2 className="project-title">Ansuvara Heights - A Landmark in Development</h2>
                    
                    <p>
                      Ansuvara Heights is the flagship residential project of Ansuvara Group and one of the largest planned developments in modern Pokhara. Spanning 170 ropanis in the rapidly expanding urban region of Talchowk, along the Prithvi Highway, the project represents the Group's commitment to creating elevated, future-ready living spaces. Designed with a long-term and community-centric vision, Ansuvara Heights features premium plotted housing, residential blocks, and thoughtfully designed layouts that emphasize both structural excellence and long-term liveability.
                    </p>
                    <p>
                      The site enjoys rare geographic privilege, panoramic Himalayan views on one side and a serene stretch overlooking the lake on the other, offering residents a living experience that seamlessly blends Pokhara's natural charm with metropolitan comfort. Its location provides quick access to essential amenities such as schools, colleges, hospitals, banks, and public transportation, making it an attractive address for families, young professionals, retirees, and investors seeking long-term value. The surrounding neighborhoods of Talchowk are evolving into one of Pokhara's most desirable residential destinations, benefiting from growing commercial activity and improved road connectivity.
                    </p>
                    <p>
                      A key highlight enhancing the value and convenience of Ansuvara Heights is the development of a Bhat-Bhateni Supermarket within the premises. A portion of the project's land was strategically sold for this landmark retail expansion, ensuring residents have immediate access to modern shopping facilities, groceries, household needs, and lifestyle conveniences just steps from their homes. This integration of premium residential living with Nepal's leading retail chain creates a holistic living environment that enhances both the quality of life and the long-term property appreciation of the area.
                    </p>
                    <p>
                      With its scale, planning, and commitment to superior infrastructure, Ansuvara Heights represents not only a residential opportunity but also a significant milestone in Pokhara's journey toward structured and sustainable urban growth, an achievement that reflects the broader vision and capabilities of Ansuvara Group.
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default RealEstate;
